export default __webpack_public_path__ + "static/media/doa.7a16f457.png";